// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"vn-z","selected":"wn-z"};